import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { affiliateApi } from "../util/api/affiliateApi";
import { trackReferralCapture } from "../util/referralCapture";

export const REFERRAL_COOKIE = "wavemind_referral";
export const REFERRAL_MAX_AGE = 30 * 24 * 60 * 60;

// Capture public referral codes independently of customer and affiliate login state.
export default function AffiliateReferral() {
  const { search } = useLocation();
  const latest = useRef(0);

  useEffect(() => () => { latest.current += 1; }, []);
  useEffect(() => {
    const values = new URLSearchParams(search).getAll("ref");
    if (!values.length) return; // Ordinary navigation must not extend the attribution window.
    const sequence = ++latest.current;
    const code = values[0];
    if (values.length !== 1 || !/^[A-Za-z0-9_-]{1,32}$/.test(code)) return;

    trackReferralCapture(affiliateApi.resolveReferral(code).then(result => {
      // A slower response from an older link must never overwrite the latest link.
      if (sequence !== latest.current || result.referral_code !== code) return;
      const expires = new Date(Date.now() + REFERRAL_MAX_AGE * 1000).toUTCString();
      const secure = window.location.protocol === "https:" ? "; Secure" : "";
      document.cookie = `${REFERRAL_COOKIE}=${encodeURIComponent(code)}; Max-Age=${REFERRAL_MAX_AGE}; Expires=${expires}; Path=/; SameSite=Lax${secure}`;
    }).catch(() => {
      // Invalid links, unavailable services, or blocked cookies must not interrupt shopping.
    }));
  }, [search]);

  return null;
}
